import immutableUpdate from 'immutable-update'

// Campos excluidos para la limpieza del arbol de bloques del contenido

const excludeattribs = [
  'blockid',
  'content',
  // 'name',
  'blocks',
  'description'
]

// Listado y evaluacion de slide blocks para controlar la navegacion

const evaluateslide = (slideblock, completed) => {

  slideblock.blocks
  .forEach(block => {

    if(
      block.evaluable &&
      block.status != 1
    ) {

      completed = completed && false
    }

    if(block.blocks) {

      completed = evaluateslide(block, completed)
    }
  })

  return completed
}

const updateblockslides = (blocks, slides) => {

  const s = slides || []

  blocks
  .forEach(block => {

    if(block.name == 'playmotivcloud/slide') {

      if(block.interceptor) {
        
        block.completed = evaluateslide(block, true)
      }

      s.push(block)

    }  else {

      updateblockslides(block.blocks, s)
    }
    
  })

  return s
}

// Limpieza del arbol de bloques del contenido
// para crear el arbol que se guarda

const getdatatree = blocks => {

  if(!blocks) return 

  return blocks
  .map(block => {

    const b = {
      blockid: block.blockid
    }

    Object.keys(block)
    .forEach(key => {

      if(!excludeattribs.includes(key)) {

        b[key] = block[key]
      }
    })

    if(block.blocks && block.blocks.length) {

      b.blocks = getdatatree(block.blocks)
    }
    
    return b
  })
}

// Conversion de arbol a lista de ids 
// para facilitar la actualizacion de atributos por interacción

const getblocksbyid = (blocks, list) => {

  if(!blocks) return 

  const l = list || {}

  blocks
  .forEach(
    block => {

      l[block.blockid] = block

      if(block.blocks) {

        getblocksbyid(block.blocks, l)
      }
    }
  )

  return l
}

// Actualización del arbol de bloques 

const updatedtree = (state, blocktree) => {

  blocktree.forEach((block, index) => {

    blocktree[index] = immutableUpdate(
      block,
      state.blocksbyid[block.blockid]
    ) 

    if(blocktree[index].blocks) {

      blocktree[index].blocks = updatedtree(state, blocktree[index].blocks)
    } 
  })
  
  return blocktree
}

export default { 

  // Evento click para botones (anterior/siguiente) colocados en el editor de contenido
  
  click: (state, dispatch, e)  => {      

    if (!e.target) return;
    if (typeof e.target.className !== "string") return;

    const isButtonLink = e.target.className.includes('wp-block-button__link')

    if(isButtonLink) {

      // Button siguiente para slides

      if(state.isslider) {

        const isContentSig = e.target.parentNode.className.includes('content-siguiente')
        if(isContentSig) {

          e.preventDefault()

          if(state.actualSlide < state.domslides.length - 1) {

            dispatch({
              actualSlide: state.actualSlide + 1
            })
          }
        }

        // Button siguiente

        const isContentAnt = e.target.parentNode.className.includes('content-anterior')
        if(isContentAnt) {

          e.preventDefault()

          if(state.actualSlide > 0) {

            dispatch({
              actualSlide: state.actualSlide - 1
            })
          }
        }     

        if(isContentSig || isContentAnt) {   

          dispatch({
            type: 'UPDATESLIDES'
          })   
    
          dispatch({
            type: 'SAVESTATE'
          })
        }
      }

      // Button route

      const isContentRoute = e.target.parentNode.className.includes('content-route')

      if(isContentRoute) {

        e.preventDefault()

        navigate(e.target.getAttribute('href'))
      }
    }
  },   

  // Actualiza el arbol de bloques con atributos modificados en la interaccion

  updateblockslides: (blocktree, completed) => updateblockslides(blocktree, completed),

  // Actualiza el arbol de bloques con atributos modificados en la interaccion

  updatedtree: (state, blocktree) => updatedtree(state, blocktree),  

  // Llamada desde el componente content con el ibjeto blocks del contenido

  blocks: (dispatch, contentblocks) => {

    if(!contentblocks) return 

    const datatree = getdatatree(contentblocks)
    const blockslides = updateblockslides(datatree)
    const blocksbyid = getblocksbyid(datatree)

    dispatch({
      blockslides: blockslides,
      datatree: datatree,
      blocksbyid: blocksbyid
    })

    dispatch({
      type: 'UPDATESLIDES'
    })  
    
    dispatch({
      type: 'SAVESTATE'
    })
  },

  // Navegación con los botones prev/next del componente
  
  navslide: (inc, state, dispatch) => {

    dispatch({
      actualSlide: state.actualSlide + inc
    })

    dispatch({
      type: 'UPDATESLIDES'
    })  
    
    dispatch({
      type: 'SAVESTATE'
    })
  }
}